export enum EnumTongHaoStatus {
  Follow = '0',
  Discover = '1',
  InkLightUpLife = '2',
  GoodHomework = '3',
  StudyInsight = '4',
  BackToHoushan = '5',
  SnackTime = '6',
  XuantongGathering = '7',
  ClassmateGathering = '8',
  ClassmateWork = '9',
  FenTong = '10'
}

export enum EumJoinStatus {
  // 待入群
  Join = '1',
  // 待退出
  Exit = '2'
}
